<template>
    <div class="login-form">

        <span>QUIERO INGRESAR CON MI NÚMERO MÓVIL</span>
        <label class="switch">
        <input type="checkbox" v-model="tab_inicio_session">
        <span class="slider round"></span>
        </label>

        <form @submit.prevent="submit"
        v-if="!this.tab_inicio_session"
            ref="login-form-form"
            novalidate
            :class="{
                'was-validated': wasValidated
            }">
            <div class="form-group">
                <input type="email"
                    class="form-control"
                    id="login-form-email"
                    aria-describedby="emailHelp"
                    placeholder="Email"
                    required
                    v-model="email">
                <div class="invalid-feedback">Email inválido</div>
            </div>
            <div class="form-group">
                <input type="password"
                    class="form-control"
                    id="login-form-password"
                    placeholder="Password"
                    required
                    v-model="password">
                <div class="invalid-feedback">Password inválido</div>
            </div>
            <div class="form-group text-center">
                <button class="btn btn-primary w-100 btn-noradius gtm-inicio-sesion-header">
                    Iniciar sesión
                    <spinner v-if="isSubmitting" />
                </button>
            </div>
            <div class="form-group text-center">
                <a href="#"
                    @click="olvido_password">
                    Olvidé mi contraseña
                </a>

                <hr>
                <p class="text-center">¿AUN NO ESTAS REGISTRADO?</p>
                    <a href="#register" class="btn btn-secondary"
                            title="Iniciar sesión"
                            @click="toggleRegistroModal(true)">
                            Registrate
                        </a>

            </div>
            <div class="login-form-message" v-if="loginMessageShow">
                    <div class="login-form-message" v-html="loginMessage">
                    </div>
                <button  @click="envio_activar_usuario" class="btn btn-primary w-100 btn-noradius" v-if="ButtonActivarEnvioCorreo">
                    Reenviar correo de activación
                </button>

            </div>

        </form>


         <form @submit.prevent="submit_telefono"
            v-if="this.tab_inicio_session"
            ref="login-form-form"
            novalidate
            :class="{
                'was-validated': wasValidated
            }">
            <div class="form-group">
                        <input type="number"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                'is-valid': validated && isTelefonoValid && telefono != ''
                            }"
                            name="email"
                            id="registro-form-telefono"
                            aria-describedby="telefonoHelp"
                            placeholder="Número de teléfono Ej: 912345678"
                            required
                            autocomplete="off"
                            v-model="telefono">
                        <div class="invalid-feedback">Teléfono inválido</div>
                    </div>
            <div class="form-group text-center">
                <button class="btn btn-primary w-100 btn-noradius gtm-inicio-sesion-header">
                    Iniciar sesión
                    <spinner v-if="isSubmitting" />
                </button>
                <div v-if="typeof this.$route.query.sus == 'undefined'" style="display: block;" class="invalid-feedback">Opcion válida sólo para suscriptores móviles activos</div>

            </div>
            <div class="form-group text-center" v-if="typeof this.$route.query.sus == 'undefined'">
                <a href="#"
                    @click="olvido_password">
                    Olvidé mi contraseña
                </a>

                <hr>
                <p class="text-center">¿AUN NO ESTAS REGISTRADO?</p>
                    <a href="#register" class="btn btn-secondary"
                            title="Iniciar sesión"
                            @click="toggleRegistroModal(true)">
                            Registrate
                        </a>

            </div>
            <div class="login-form-message" v-if="loginMessageShow">
                    <div class="login-form-message" v-html="loginMessage">
                    </div>
                <button  @click="envio_activar_usuario" class="btn btn-primary w-100 btn-noradius" v-if="ButtonActivarEnvioCorreo">
                    Reenviar correo de activación
                </button>

            </div>

        </form>



    </div>

</template>

<script>
import { mapState, mapGetters } from "vuex";
import {  isValidTelefono } from "../utilities/util";
import Spinner from "./Spinner";
export default {
	components: { Spinner },
	data() {
		return {
			email:
				typeof this.$route.query.activar != "undefined"
					? this.$route.query.activar
					: (typeof this.$route.query.creada != "undefined"
					? this.$route.query.creada
					: (typeof this.$route.query.login != "undefined"
					? this.$route.query.login
					: "")),
			password:
				typeof this.$route.query.activar != "undefined" ? "123456" : (typeof this.$route.query.password != "undefined"
					? this.$route.query.password
					: ""),
            wasValidated: false,
            telefono: "",
			isSubmitting: false,
			loginMessage: "",
			loginMessageShow: false,
            ButtonActivarEnvioCorreo:false,
            tab_inicio_session:false,
            validated: false,

        };
    },
    computed: {
		isTelefonoValid() {
			return isValidTelefono(this.telefono);
        },

	},
	watch: {
		email(val, old) {
			this.wasValidated = false;
		},
		password(val, old) {
			this.wasValidated = false;
		}
    },
	methods: {
		olvido_password() {
			this.$store.commit("togglePortalLoginModal", false);
			this.$router.push({ name: "olvido_password" });
		},
		envio_activar_usuario() {

            let newUserData = {
				email: this.email
			};

			this.$api
					.envio_activar_usuario(newUserData)
					.then(response => {
						console.log(response.data);
						if (response.data.response != "200") {

                            alert("Error al enviar correo")

								this.$router.push({
									name: "home"
								});
						} else {
                            alert("Correo enviado con exito")
								this.$router.push({
									name: "home"
								});
						}
					})
					.catch(error => {

                        alert("Error al enviar correo")
							this.$router.push({
								name: "home"
							});
					});
        },
        toggleRegistroModal(toggle) {
			this.$store.commit("togglePortalRegistroModal", toggle);
			this.$store.commit("togglePortalLoginModal", false);
		},
		submit() {
			this.wasValidated = true;
			if (this.email != "" && this.password != "") {
				this.isSubmitting = true;
				this.$store
					.dispatch("login", {
						email: this.email,
						password: this.password
					})
					.then(response => {
						this.loginMessage = "";
						this.loginMessageShow = false;
						this.$emit("loginSuccessful", response);
                        this.isSubmitting = false;

                        localStorage.setItem("name_user",response.name);
                        localStorage.setItem("email_user", response.email);
                        console.log("aaaaa",response)


                        dataLayer.push({
                            'event': 'sesion-iniciada',
                        });

		              if (typeof this.$route.query.activar != "undefined" || (typeof this.$route.query.creada != "undefined" && typeof this.$route.query.password != "undefined")) {
							this.$router.push({ name: "perfil" });
						}
					})
					.catch(error => {
                    this.ButtonActivarEnvioCorreo=false;
                    if(error=="USER INACTIVO"){
                        this.ButtonActivarEnvioCorreo=true;
                    }
						this.loginMessage =
							"Error al iniciar sesión, revise el email y el password.";
						this.loginMessageShow = true;
						this.$emit("loginError", error);
						this.isSubmitting = false;
					});
			}
		},
		submit_telefono() {
			this.wasValidated = true;
			if (this.telefono != "" ) {

            this.validated = true;
			let isValid = true;
			if (
				!this.isTelefonoValid
			)
				isValid = false;

            if (!isValid) return false;


				this.isSubmitting = true;
				this.$store
					.dispatch("login", {
                        telefono: this.telefono,
                        validarEntrada: "PORTAL",
					})
					.then(response => {
						this.loginMessage = "";
						this.loginMessageShow = false;
						this.$emit("loginSuccessful", response);
                        this.isSubmitting = false;

                        localStorage.setItem("name_user",response.name);
                        localStorage.setItem("email_user", response.email);
                        console.log("aaaaa",response)

                        dataLayer.push({
                            'event': 'sesion-iniciada',
                        });


		              if (typeof this.$route.query.activar != "undefined" || (typeof this.$route.query.creada != "undefined" && typeof this.$route.query.password != "undefined")) {
							this.$router.push({ name: "perfil" });
						}
					})
					.catch(error => {
                    this.ButtonActivarEnvioCorreo=false;
                    if(error=="USER INACTIVO"){
                        this.ButtonActivarEnvioCorreo=true;
                    }
						this.loginMessage =
							"Error al iniciar sesión, revise el número de teléfono.";
						this.loginMessageShow = true;
						this.$emit("loginError", error);
						this.isSubmitting = false;
					});
			}
		}
	},
	mounted() {
		if (typeof this.$route.query.activar != "undefined" || (typeof this.$route.query.creada != "undefined" && typeof this.$route.query.password != "undefined")) {
			console.log("activar parametros");
			this.$store.commit("togglePortalLoginModal", true);
			this.submit();
		}

        if (typeof this.$route.query.login != "undefined") {
			console.log("activar parametros");
			this.$store.commit("togglePortalLoginModal", true);
        }

        if (typeof this.$route.query.sus != "undefined" ) {

            //Caso en que el email user es null
            if( localStorage.getItem("email_user") === null ){
                this.tab_inicio_session=true;
			    console.log("activar parametros");
			    this.$store.commit("togglePortalLoginModal", true);
            }else{
                if(localStorage.getItem("email_user") == "Visitante"){
                    this.tab_inicio_session=true;
			        console.log("activar parametros");
			        this.$store.commit("togglePortalLoginModal", true);
                }
            }

		}
	}
};
</script>
<style >
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
height: 20px;
  margin-left: 15px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
      border: 1px solid #ccc;
    height: 20px;
    width: 20px;
    left: -3px;
    bottom: 0px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #24CCC0;
}

input:focus + .slider {
  box-shadow: 0 0 1px #24CCC0;
}

input:checked + .slider:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>


